// @generated
// AUTO-GENERATED by scripts/generate-fhir-terminologies.ts. Do not edit.
// Run: npm run generate:terminologies
// Source: apps/ig/input/resources/code-systems/problem-category.json
export const URL = 'http://alopexcare.com/fhir/CodeSystem/problem-category';
export const SYSTEM = URL;
export const concepts = [
    { code: 'cognitive', display: 'Cognitive', displayUi: 'Cognitive', system: 'http://alopexcare.com/fhir/CodeSystem/problem-category' },
    { code: 'functional', display: 'Functional', displayUi: 'Functional', system: 'http://alopexcare.com/fhir/CodeSystem/problem-category' },
    { code: 'medical', display: 'Medical', displayUi: 'Medical', system: 'http://alopexcare.com/fhir/CodeSystem/problem-category' },
    { code: 'mental-health', display: 'Mental Health', displayUi: 'Mental Health', system: 'http://alopexcare.com/fhir/CodeSystem/problem-category' },
    { code: 'psychosocial', display: 'Psychosocial', displayUi: 'Psychosocial', system: 'http://alopexcare.com/fhir/CodeSystem/problem-category' },
    { code: 'advance-directive-need', display: 'Advance Directive Need', displayUi: 'Advance Directive Need', system: 'http://alopexcare.com/fhir/CodeSystem/problem-category' },
];
export function isValidCode(value) {
    return concepts.some((c) => c.code === value);
}
/** Returns the UI display (designation override if present, else canonical display). */
export function getDisplay(code) {
    return concepts.find((c) => c.code === code)?.displayUi ?? '';
}
/**
 * Build a FHIR Coding with the canonical display (NOT displayUi) to preserve
 * server-side terminology-binding validity. Use getDisplay() for UI rendering.
 */
export function toCoding(code) {
    const concept = concepts.find((c) => c.code === code);
    return { system: concept?.system ?? '', code, display: concept?.display ?? '' };
}
